import { render, staticRenderFns } from "./DamageDegreeSelect.vue?vue&type=template&id=0741fa28&scoped=true&"
import script from "./DamageDegreeSelect.vue?vue&type=script&lang=js&"
export * from "./DamageDegreeSelect.vue?vue&type=script&lang=js&"
import style0 from "./DamageDegreeSelect.vue?vue&type=style&index=0&id=0741fa28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0741fa28",
  null
  
)

export default component.exports